<div class="flex flex-col md:flex-row-reverse grow">
  <div
    class="h-[300px] md:h-full w-100 overflow-hidden flex flex-col justify-end"
  >
    <div class="w-100 h-100 image"></div>
  </div>
  <div class="flex flex-col md:justify-center grow px-8 pt-8">
    <et-login-screen
      (loginClicked)="onLogin()"
      (registerClicked)="onRegister()"
      [changeCatalogEnabled]="false"
    ></et-login-screen>

    <button (click)="onWithoutLogin()" mat-button>
      <mat-icon>arrow_forward</mat-icon>
      {{ 'login.without_login' | translate }}
    </button>
  </div>
</div>
